import { render, staticRenderFns } from "./LargeScreenDisplay.vue?vue&type=template&id=bbf2cb0a&scoped=true"
import script from "./LargeScreenDisplay.vue?vue&type=script&lang=js"
export * from "./LargeScreenDisplay.vue?vue&type=script&lang=js"
import style0 from "./LargeScreenDisplay.vue?vue&type=style&index=0&id=bbf2cb0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf2cb0a",
  null
  
)

export default component.exports